import { useDeleteCompany as useDeleteCompanyMutation } from '@api';
import { useNotification } from '@common';
import { modals } from '@mantine/modals';
import { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';

const TRANS_PATH = 'TABLE.ACTIONS';
const TRANS_PATH_NOTIFICATION = 'NOTIFICATIONS.DELETE_COMPANY';

type UseDeleteCompanyReturnType = {
  handleDeleteCompany: (companyId: string) => void;
};

export const useDeleteCompany = (): UseDeleteCompanyReturnType => {
  const { t } = useTranslation('companies');
  const { showSuccess, showError } = useNotification();
  const { mutate: mutateDelete } = useDeleteCompanyMutation();

  const onSuccess = (): void => {
    showSuccess({
      title: `${TRANS_PATH_NOTIFICATION}.SUCCESS.TITLE`,
      message: `${TRANS_PATH_NOTIFICATION}.SUCCESS.MESSAGE`,
    });
  };

  const onError = (error: AxiosError): void => {
    showError({
      title: `${TRANS_PATH_NOTIFICATION}.ERROR.TITLE`,
      message: `${TRANS_PATH_NOTIFICATION}.ERROR.MESSAGE`,
      error,
    });
  };

  const onConfirm = (companyId: string): void => {
    mutateDelete({ companyId }, { onSuccess, onError });
  };

  const handleDeleteCompany = (companyId: string): void => {
    modals.openConfirmModal({
      title: t(`${TRANS_PATH}.DELETE_CONFIRMATION_TITLE`),
      labels: {
        confirm: t(`${TRANS_PATH}.DELETE_CONFIRM_BUTTON`),
        cancel: t('CANCEL_BUTTON', { ns: 'common' }),
      },
      confirmProps: {
        color: 'red',
      },
      onConfirm: () => onConfirm(companyId),
    });
  };

  return { handleDeleteCompany };
};
